(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('TableauCotisationsATCtrl', TableauCotisationsATCtrl);

    TableauCotisationsATCtrl.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function TableauCotisationsATCtrl ($scope, $state, ParseLinks, AlertService) {
        var vm = this;
    }
})();
